module.exports = __webpack_public_path__ + "static/media/image3.91ed669d.jpg";